<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>数据订正表格</span>
      <el-button type="primary" style="float: right;">新增</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="date" label="日期"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="address" label="地址"></el-table-column>
      <el-table-column prop="address" label="操作">
        <template>
          <el-button size="mini">编辑</el-button>
          <el-button size="mini" type="danger">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
export default {
  name: 'mytable',
  data() {
    return {
      tableData: [
        {
          date: '2016-05-02',
          name: '展示数据',
          address: '150'
        },
        {
          date: '2016-05-04',
          name: '展示数据',
          address: '120'
        },
        {
          date: '2016-05-01',
          name: '展示数据',
          address: '80'
        },
        {
          date: '2016-05-03',
          name: '展示数据',
          address: '130'
        }
      ]
    }
  }
}
</script>

<style>
</style>